// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1341B","error":"Textarea_error__jMka_","readonly":"Textarea_readonly__1X_z5","disabled":"Textarea_disabled__2HhqL"};